module.exports = __webpack_public_path__ + "img/SL.a48fc7d0.svg";